import * as React from 'react'
import * as st from './bannerContainer.module.scss'
import * as cn from 'classnames'

type Props = {
  isRetail: boolean
}

export class BannerContainer extends React.Component<Props> {
  render() {
    const { isRetail, children } = this.props
    return <div className={cn(st.bannerContainer, { [st.sticky]: !isRetail })}>
      {children}
    </div>
  }
}
